<!-- サブスク以外表示 1日のみの場合はスタート日のみ 1日以上はスタート日&終了日 -->
<template>
  <div class="column">
    <!-- 有効期間ラベル -->
    <label class="name">{{ $t("common.validPeriod") }}</label>

    <!-- 期間の表示 book.user_XXX_atがあればそれ。なければavailable_XXX_atが入ってくる -->
    <!-- master_book.valid_period == '1days'なら、開始日のみの表示　ただし有効化前は1daysでも終了日を表示する -->
    <div class="value">
      <span class="datetime">
        {{ displayDate(start) }}
        <span v-if="period != '1days' || isBeforeValid"
          >- {{ displayDate(limit) }}</span
        >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BAvailablePeriod",
  props: {
    period: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    limit: {
      type: String,
      required: true,
    },
    isBeforeValid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  color: #888888;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
  font-size: 12px;
}

.value span {
  font-size: 14px;
}
</style>
